(function() {
    'use strict';
    angular
        .module('uniromaLandingApp')
        .factory('IdmCategoria', IdmCategoria);

    IdmCategoria.$inject = ['$resource'];

    function IdmCategoria ($resource) {
        var resourceUrl =  'api/categorie-utenti/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
